import { connectBaseApi, jobClient, createRpcMutation, createRpcQuery } from "@racoon/api";
import { PAST_DAY_CACHE_S } from "../cache";

export const jobGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    createJob: createRpcMutation(build, jobClient, "createJob", {
      invalidatesTags: ["Order"],
    }),
    updateJob: createRpcMutation(build, jobClient, "updateJob", {
      invalidatesTags: ["Order", "Routes", "Route"],
    }),
    getJobById: createRpcQuery(build, jobClient, "getJobById", {
      providesTags: (_result, _error, arg) => [{ type: "Order" as const, id: String(arg.id) }],
    }),
    listJobs: createRpcQuery(build, jobClient, "listJobs", {
      providesTags: ["Order"],
    }),
    listJobsPastDay: createRpcQuery(build, jobClient, "listJobs", {
      providesTags: ["Order"],
      keepUnusedDataFor: PAST_DAY_CACHE_S,
    }),
    cancelJob: createRpcMutation(build, jobClient, "cancelJob", {
      invalidatesTags: ["Order", "Truck", "Routes", "Route"],
    }),
    // A Невывоз job comes back as a new unassigned attempt at its order.
    reissueJob: createRpcMutation(build, jobClient, "reissueJob", {
      invalidatesTags: ["Order"],
    }),
    detachJobFromRoute: createRpcMutation(build, jobClient, "detachJobFromRoute", {
      invalidatesTags: ["Order", "Truck", "Routes", "Route"],
    }),
    forceCompleteJob: createRpcMutation(build, jobClient, "forceCompleteJob", {
      invalidatesTags: ["Order", "Truck", "Routes", "Route"],
    }),
    listOperationTimeWindowJobs: createRpcQuery(build, jobClient, "listOperationTimeWindowJobs", {
      providesTags: ["Order"],
    }),
    attachJobInstructions: createRpcMutation(build, jobClient, "attachJobInstructions", {
      invalidatesTags: ["Order"],
    }),
    detachJobInstructions: createRpcMutation(build, jobClient, "detachJobInstructions", {
      invalidatesTags: ["Order"],
    }),
    // The photo-report modal also opens from route and container rows, whose jobs
    // live in those caches — refresh them too so the new photo shows up there.
    uploadJobFile: createRpcMutation(build, jobClient, "uploadJobFile", {
      invalidatesTags: ["Order", "Routes", "Route", "Container"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateJobMutation,
  useUpdateJobMutation,
  useGetJobByIdQuery,
  useListJobsQuery,
  useListJobsPastDayQuery,
  useLazyListJobsQuery,
  useCancelJobMutation,
  useReissueJobMutation,
  useDetachJobFromRouteMutation,
  useForceCompleteJobMutation,
  useListOperationTimeWindowJobsQuery,
  useAttachJobInstructionsMutation,
  useDetachJobInstructionsMutation,
  useUploadJobFileMutation,
} = jobGrpc;
